import * as React from "react";
const SvgHinzufgen = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Hinzufügen">
    <path
      fill="currentColor"
      d="M128 243.54c-63.71 0-115.54-51.83-115.54-115.54S64.29 12.46 128 12.46 243.54 64.29 243.54 128 191.71 243.54 128 243.54m0-216.08C72.56 27.46 27.46 72.56 27.46 128S72.56 228.54 128 228.54 228.54 183.44 228.54 128 183.44 27.46 128 27.46"
    />
    <path
      fill="currentColor"
      d="M188.24 120.5H135.5V67.76c0-4.14-3.36-7.5-7.5-7.5s-7.5 3.36-7.5 7.5v52.74H67.76c-4.14 0-7.5 3.36-7.5 7.5s3.36 7.5 7.5 7.5h52.74v52.74c0 4.14 3.36 7.5 7.5 7.5s7.5-3.36 7.5-7.5V135.5h52.74c4.14 0 7.5-3.36 7.5-7.5s-3.36-7.5-7.5-7.5"
    />
  </svg>
);
export default SvgHinzufgen;
